import React, { useState, useEffect } from 'react';
import { Row, Col, Drawer, Form, Input, Button, Switch, DatePicker } from 'antd';
import PropTypes from 'prop-types';
import { GLOBAL_TABLE_PAGE_SIZE, GLOBAL_TABLE_SIZE } from 'global_config/constant-global';
import { fetchPathologist, createPathologist, updatePathologist } from 'services/settings/pathologists';
import { showMessage } from 'services/settings/message';
// import './pathologists_form.css';

const PathologistForm = ({ visible, onClose, record, initialValues, closeDrawer }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    // const [initialValues, setInitialValues] = useState({});

    // console.log('Initial Values =>', initialValues);

    useEffect(() => {
        if (initialValues && Object.keys(initialValues).length) {
            form.setFieldsValue(initialValues);
        } else {
            form.resetFields();
        }
    }, [initialValues, form]);

    useEffect(() => {
        if (!visible) {
            form.resetFields();
        }
    }, [visible, form])

    const handleSubmit = async (values) => {
        try{
            if(record){
                // UPDATE PATHOLOGIST
                const response = await updatePathologist(values);
                if(response && Object.keys(response).length > 0){
                    showMessage('M0003');
                    closeDrawer();
                }
            }else{
                // CREATE PATHOLOGIST

                const response = await createPathologist(values);
                if(response && Object.keys(response).length > 0){ 
                    // console.log('response =>', response);
                    showMessage('M0002');
                    closeDrawer();
                }
            }

        }catch(error){
            console.error('Error in submitting pathologist form: =>', error);
            // closeDrawer();
        }
    }

    const title = record ? 'EDIT PATHOLOGIST' : 'ADD PATHOLOGIST';
    const submitButtonText = record ? 'UPDATE' : 'ADD';
    const isUpdate = record ? true : false;


    return(
        <Drawer visible={visible} title={title} onClose={onClose} width={600} destroyOnClose={true}>
            <Form form={form} initialValues={initialValues} onFinish={handleSubmit} layout='vertical'>
            <section className="pathologist-form-section">
                <Row>
                    <Col>
                        <Form.Item name="isActive" label="STATUS" valuePropName='checked'>
                            <Switch defaultChecked disabled={isUpdate ? false : true}/>
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item name="pathologistID" label="PATHOLOGIST ID" hidden></Form.Item>
                        <Form.Item name="pathologistFirstName" label="FIRST NAME"
					        rules={[{ required: true, message: 'First Name is required' }]}
                        >
                            <Input maxLength={100}/>
                        </Form.Item>
                        <Form.Item name="pathologistMiddleName" label="MIDDLE NAME">
                            <Input maxLength={100}/>
                        </Form.Item>
                        <Form.Item name="pathologistLastName" label="LAST NAME"
					        rules={[{ required: true, message: 'Last Name is required' }]}
                        >
                            <Input maxLength={100} />
                        </Form.Item>
                        <Form.Item name="pathologistValidity" label="VALIDITY"
                            rules={[{ required: true, message: 'Validity is required' }]}
                        >
                            <DatePicker format={'MM-DD-YYYY'}/>
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item name="pathologistPrefix" label="PREFIX">
                            <Input maxLength={50} />
                        </Form.Item>
                        <Form.Item name="pathologistSuffix" label="SUFFIX">
                            <Input maxLength={50} />
                        </Form.Item>
                        <Form.Item name="pathologistDegree" label="DEGREE">
                            <Input maxLength={100}/>
                        </Form.Item>
                        <Form.Item name="pathologistLicenseNo" label="LICENSE NO."
                            rules={[{ required: true, message: 'License No. is required' }]}
                        >
                            <Input maxLength={50}/>
                        </Form.Item>
                    </Col>
                </Row>
                </section>
                <section className='drawerFooter'>
                    <React.Fragment>
                    {/* <Form.Item> */}
                    <Button
                        shape='round'
                        onClick={closeDrawer}
                        style={{ margin: 5, width: 120 }}
                        >CANCEL
                    </Button>
                        <Button 
                            type="primary" 
                            shape='round' 
                            htmlType="submit" 
                            style={{ margin: 5, width: 120 }}
                            loading={loading}>
                            {submitButtonText}
                        </Button>
                    {/* </Form.Item> */}
                    </React.Fragment>
                </section>
            </Form>
        </Drawer>
    );
}

PathologistForm.propTypes = {
    visible: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    record: PropTypes.object,
    initialValues: PropTypes.object,
    closeDrawer: PropTypes.func.isRequired
};

PathologistForm.defaultProps = {
    record: null,
    onClose: () => {},
    closeDrawer: () => {},
    initialValues: {}
};

export default PathologistForm;